import React, { useEffect } from 'react'
import { useStore } from '../../../store/store';
import { Select } from 'antd';
import { useTranslation } from 'react-i18next';
const { Option } = Select

const TriggerValueYesNo = ({ box, value, record }) => {
  const { t } = useTranslation()
  const updateTrigger = useStore(({ updateTrigger }) => updateTrigger)

  // Valeur par défaut "yes" si aucune valeur n'est définie
  const currentValue = value || 'yes';

  // S'assurer que la valeur est toujours définie lors du premier rendu
  useEffect(() => {
    if (!value) {
      updateTrigger(record.id, box.id, { value: 'yes' });
    }
  }, [value, record.id, box.id, updateTrigger]);

  const updateValue = (newValue) => {
    // S'assurer qu'une valeur est toujours définie
    updateTrigger(record.id, box.id, { value: newValue || 'yes' })
  }

  return (
    <div style={{
      display: 'flex',
      width: "100%"
    }}>
      <Select
        style={{
          width: "100%"
        }}
        popupClassName="trigger-select-name"
        bordered={false}
        showSearch={false}
        value={currentValue}
        suffixIcon={null}
        onChange={updateValue}
        disabled={record.from_linked_section}
      >
        <Option key="yes" value="yes" label={t('yes')}>
          {t('yes')}
        </Option>
        <Option key="no" value="no" label={t('no')}>
          {t('no')}
        </Option>
      </Select>
    </div>
  )
}

export default TriggerValueYesNo
